import { RespCodeMsgObjType } from '.';
const SERVE_ERR = '服务异常，请稍后重试';
const LOGIN_MSG = '请先登录';
const LOGIN_DESC = '用户未登录';
export default {
  ok: {
    msg: '',
    desc: '数据正常',
  },
  client_network_error: {
    msg: '网络故障，请重试',
    desc: '网络故障',
  },
  error: {
    msg: '服务器故障，正在抢修中...（错误码：1000）',
    desc: '致命错误',
  },
  locked: {
    msg: '操作过频，请稍后再试',
    desc: '触发防重入拦截',
  },
  invalid_params: {
    msg: '服务器故障，正在抢修中...（错误码：1001）',
    desc: '参数错误',
  },
  no_login: {
    msg: LOGIN_MSG,
    desc: LOGIN_DESC,
    notToSentry: true,
    enable: false,
  },
  userNotLogin: {
    msg: LOGIN_MSG,
    desc: LOGIN_DESC,
    notToSentry: true,
    enable: false,
  },
  err_user_not_login: {
    msg: LOGIN_MSG,
    desc: LOGIN_DESC,
    enable: false,
  },
  err_not_found_team_id: {
    msg: SERVE_ERR,
    desc: '找不到team id对应的团队',
  },
  err_third_user_no_third_auth: {
    msg: SERVE_ERR,
    desc: '三方用户并未三方授权',
  },
  err_team_no_associate_partner: {
    msg: SERVE_ERR,
    desc: '顶级团队没有找到绑定的公共邀请团队',
  },
  err_parse_hot_search_setting: {
    msg: SERVE_ERR,
    desc: '解析热搜词配置失败',
  },
  err_add_invite_confirm_topic_failed: {
    msg: SERVE_ERR,
    desc: '分发邀请人员增量队列失败',
  },
  err_not_found_user_did: {
    msg: SERVE_ERR,
    desc: '找不到用户did信息',
  },
  err_not_found_user_info: {
    msg: SERVE_ERR,
    desc: '找不到用户信息',
  },
  err_not_founded_user_auth: {
    msg: SERVE_ERR,
    desc: '找不到 user auth',
  },
  err_not_found_app_rights: {
    msg: SERVE_ERR,
    desc: '找不到相关的应用权益记录',
  },
  err_not_founded_team_rights: {
    msg: SERVE_ERR,
    desc: '团队权益找不到',
  },
  err_order_pay_cb_invalid_params: {
    msg: SERVE_ERR,
    desc: '续费或升级时，回调参数被篡改',
  },
  err_improper_purchase_type: {
    msg: SERVE_ERR,
    desc: '不合适的购买类型，续费时，应该还是在有效期。不是在有效期，应该是新购',
  },
  err_not_allow_delete_paid_app: {
    msg: '',
    desc: '应用单购且仍有效，不允许删除',
    enable: false,
  },
  err_not_team_admin: {
    msg: '暂无权限，请联系工作区拥有者或切换至自己的工作区',
    desc: '不是工作区管理员',
  },
  err_not_team_owner: {
    msg: '暂无权限，请联系工作区拥有者或切换至自己的工作区',
    desc: '不是团队拥有者',
  },
  err_not_allow_pay_for_free_app: {
    msg: SERVE_ERR,
    desc: '不允许为免费的应用支付',
  },
  err_team_paid_still_effective: {
    msg: SERVE_ERR,
    desc: '平台版仍然有效，不允许购买',
  },
  // err_user_existed_owned_team_already: {
  //   msg: '',
  //   desc: '用户已经存在自己的团队了',
  // },
  err_team_members_reach_limit: {
    msg: '当前工作区人数已满，暂不支持加入',
    desc: '团队用户达到限制数量',
  },
  err_invalidPartner_id: {
    msg: SERVE_ERR,
    desc: '非法partner_id',
  },
  err_invalid_category_id: {
    msg: SERVE_ERR,
    desc: '非法分类id',
  },
  err_invalid_tpl_id: {
    msg: SERVE_ERR,
    desc: '非法的模板id',
  },
  err_invalid_platform_id: {
    msg: SERVE_ERR,
    desc: '非法platform_id',
  },
  err_invalid_ak: {
    msg: SERVE_ERR,
    desc: '非法的ak',
  },
  err_invalid_order_cb_extra_json: {
    msg: SERVE_ERR,
    desc: '非法的支付回调json格式',
  },
  err_invalid_purchase_type: {
    msg: SERVE_ERR,
    desc: '非法的支付类型',
  },
  err_invalid_sub_svc_rights_sync_params: {
    msg: SERVE_ERR,
    desc: '子服务权益同步参数非法',
  },
  err_no_match_pay_config: {
    msg: SERVE_ERR,
    desc: '支付回调中的payconfig 不匹配配置的payconfig',
  },
  err_invalid_pay_pre_order_params: {
    msg: SERVE_ERR,
    desc: '非法的预下单请求参数',
  },
  err_invalid_did: {
    msg: SERVE_ERR,
    desc: '非法的did',
  },
  err_invalid_team_member: {
    msg: '您已被移出【$0】', // 这里是个动态信息值($0 用于提供给外部函数执行替换内容)，完整为：’附件过大，最大支持200M‘
    isDynMsg: true,
    desc: '非法用户',
    /** 强制刷新 */
    forceReloadPage: true,
  },
  err_team_member_disabled: {
    msg: '您已被【$0】禁用', // 这里是个动态信息值($0 用于提供给外部函数执行替换内容)，完整为：’附件过大，最大支持200M‘
    isDynMsg: true,
    desc: '成员已经被禁用',
    /** 强制刷新 */
    forceReloadPage: true,
  },
  err_invalid_access_params: {
    msg: '无效链接，暂不支持访问',
    desc: '访问中间页，非法访问参数',
  },
  err_rights_trial_expired: {
    msg: '',
    desc: '试用期到期',
    enable: false,
  },
  err_rights_paid_expired: {
    msg: '',
    desc: '权益到期',
    enable: false,
  },
  err_invalid_middle_page_check_mode: {
    msg: '无效链接，暂不支持访问',
    desc: '非法的中间页检查模式参数',
  },
  err_black_list_hit: {
    msg: '无效链接，暂不支持访问',
    desc: '链接黑名单',
  },
  err_invalid_access_token: {
    msg: SERVE_ERR,
    desc: '非法access_token',
  },
  err_call_open_partner_api_failed: {
    msg: SERVE_ERR,
    desc: '',
  },
  err_call_card_service_api_failed: {
    msg: SERVE_ERR,
    desc: '',
  },
  err_call_sub_svc_api_failed: {
    msg: SERVE_ERR,
    desc: '',
  },
  err_third_login_failed: {
    msg: SERVE_ERR,
    desc: '',
  },
  err_call_open_api_failed: {
    msg: SERVE_ERR,
    desc: '',
  },
  // #region 子服务透传
  err_workspace_apps_exceed_limit: {
    msg: '工作区应用数已达上限，无法创建应用',
    desc: '工作区应用数已达上限，无法创建应用',
  },
  // #endregion
  // FIXME:需要在此处补充当前项目的ajax错误描述内容
} as Record<string, RespCodeMsgObjType>;
